import { BreakpointObserver, MediaMatcher, LayoutModule } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';

import { navItems as defaultNavItems } from './sidebar/data/sidebar-data';
import { navItems as adminNavItems } from './sidebar/data/admin-sidebar-data';
import { navItems as clientNavItems } from './sidebar/data/client-sidebar-data';
import { navItems as storeNavItems } from './sidebar/data/store-sidebar-data';
import { navItems as clubNavItems } from './sidebar/data/club-sidebar-data';
import { navItems as fichaMotorNavItems } from './sidebar/data/ficha-motor-sidebar-data';

import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './header/header.component';
import { AuthService } from 'src/app/services/auth.service';
import { NavItem } from './sidebar/nav-item/nav-item';
import { StorageService } from 'src/app/services/storage.service';
import { TarjetaService } from '../../services/tarjeta.service';
import { PerfilService } from '../../services/perfil.service';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';


@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    LayoutModule,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
  ],
  templateUrl: './full.component.html',
  styleUrl: './full.component.scss',
  encapsulation: ViewEncapsulation.None,
})

export class FullComponent implements OnInit {

  navItems: NavItem[] = [];
  stores: any[] = [];
  selectedStore: any[] = [];

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav | any;


  //get options from service
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private storageService: StorageService,
    private authService: AuthService,
    private tarjetaService: TarjetaService,
    private perfilService: PerfilService,
    @Inject(PLATFORM_ID) private platformId: Object) {

    if (isPlatformBrowser(this.platformId)) {
      this.htmlElement = document.querySelector('html')!;
      this.htmlElement.classList.add('light-theme');
      this.layoutChangesSubscription = this.breakpointObserver
        .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
        .subscribe((state) => {
          // SidenavOpened must be reset true when layout changes
          this.isMobileScreen = state.breakpoints[MOBILE_VIEW];
          this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        });
    }
  }

  ngOnInit(): void {
    this.stores = this.storageService.getStores();
    const storedSelectedStore = this.storageService.getSelectedStore();
    this.selectedStore = this.stores.find(store => store.id === storedSelectedStore?.id) || null;
    this.loadNavItemsBasedOnProfile();
  }


  // Cargar los navItems según el perfil
  private loadNavItemsBasedOnProfile(): void {
    const userProfile = this.authService.getProfileFromToken(); // Obtener perfil del token (o lo que sea necesario)

    switch (userProfile) {
      case 1: // Admin
        this.navItems = adminNavItems;
        break;
      case 2: // Client
        this.loadClientMenu();
        break;
      case 4: // Temp Client
        this.navItems = [];
        this.sidenav.close();
        break;
      case 3: // Store
        this.navItems = storeNavItems;
        break;
      case 5: // Club
        this.navItems = clubNavItems;
        break;
      case 6: // Admin Ficha Motor
        this.navItems = fichaMotorNavItems;
        break;
      default: // Si no se encuentra el perfil, cargar el navItems por defecto
        this.navItems = defaultNavItems;
        break;
    }
  }

  private loadClientMenu(): void {
    this.navItems = clientNavItems.filter(item => item.navCap || item.route === '/client/dashboard' || item.route === '/client/beneficios');
    this.tarjetaService.getTarjetasByUser().subscribe({
      next: (tarjetas: any[]) => {
        const hasFichaMotor = (tarjetas || []).some((tarjeta: any) => tarjeta.idTipoTarjeta === 3);
        const hasTarjetas = (tarjetas || []).some((tarjeta: any) => (tarjeta.idTipoTarjeta || 1) === 1);
        this.navItems = clientNavItems.filter(item => {
          if (item.route === '/client/ficha-motor') return hasFichaMotor;
          if (item.route === '/client/contactos' || item.route === '/client/network') return hasTarjetas;
          return true;
        });
      },
      error: (err) => console.error('Error loading client menu', err),
    });
  }

  onOptionChange(event: any): void {
    this.selectedStore = event.value;
    this.storageService.saveSelectedStore(this.selectedStore);
    this.router.navigate(['/store']);
  }

  isUserStore() {
    return this.authService.isAuthenticated()
      && this.authService.getProfileFromToken() === 3;
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isCollapsedWidthFixed = !this.isCollapsedWidthFixed;
    this.isContentWidthFixed = false;
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
    this.isCollapsedWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    if (!isOpened) this.isCollapsedWidthFixed = false;
  }

  loadTempClientMenu() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.tarjetaService.getTarjetasByUser().subscribe({
        next: (tarjetas: any[]) => {
          const tarjeta = (tarjetas || []).find((item: any) => (item.idTipoTarjeta || 1) === 1) || tarjetas?.[0];
          if (tarjeta) {
            this.perfilService.getPerfilByID(tarjeta.idPerfil).subscribe({
              next: (perfil: any) => {
                const idCliente = perfil.idCliente;
                this.navItems = [
                  {
                    navCap: 'Menú',
                  },
                  {
                    displayName: 'Club Beneficios',
                    iconName: 'gift',
                    bgcolor: 'primary',
                    route: '/client/beneficios',
                  },
                  {
                    displayName: 'Editar Tarjeta',
                    iconName: 'id',
                    bgcolor: 'primary',
                    route: `/admin-client/${idCliente}/card/${tarjeta.id}`,
                  },
                ];
              },
              error: (err) => console.error('Error loading profile for menu', err)
            });
          }
        },
        error: (err) => console.error('Error loading card for menu', err)
      });
    }
  }
}
